/* eslint-disable @typescript-eslint/no-unused-vars */
/* for mobx decorators? */
import { observable } from 'mobx';
import { persist } from 'mobx-persist';

import RootStore from './RootStore';

class IdentityStore {
  @persist
  @observable
  public id: string = ``;

  protected rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
}

export default IdentityStore;
